(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["favored-product-refinements"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const link = event.target.closest('[data-favored-size-open]');
    if (!link) return;
    const guide = document.getElementById(link.dataset.favoredSizeOpen);
    if (!guide) return;
    event.preventDefault();
    guide.open = true;
    guide.querySelector('summary').focus();
    guide.scrollIntoView({block:'nearest',behavior:'auto'});
  });
  } catch(e) { console.error(e); }
})();

})();
